import { render, staticRenderFns } from "./periodical-manage.vue?vue&type=template&id=e9e1102e&scoped=true"
import script from "./periodical-manage.vue?vue&type=script&lang=js"
export * from "./periodical-manage.vue?vue&type=script&lang=js"
import style0 from "./periodical-manage.vue?vue&type=style&index=0&id=e9e1102e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9e1102e",
  null
  
)

export default component.exports